import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import url from 'url';
import {
  EuiNavDrawer,
  EuiNavDrawerGroup,
  EuiHeaderSectionItemButton,
  EuiHeaderBreadcrumbs,
  EuiHeaderLogo,
  EuiIcon,
  EuiSpacer,
} from 'stable-eui';
import { get } from 'lodash';
import { getMessage } from 'utils';
import {
  toggleNavDrawer,
  addNewRecent,
  addFavorite,
  removeFavorite,
} from '../reducers/app';
import { menuGroups } from '../app-constants/common';

const NavDrawer = (props) => {
  const [lockStatus, setLockStatus] = useState(
    localStorage.getItem('lockStatus') === 'locked'
  );
  const navDrawerRef = useRef(null);

  const buildMenu = (filterFn) => {
    const favoritedList = props.favoriteList.map((i) => i.path);
    const pageList = get(props, 'pageList', []);
    const result = [];

    pageList.filter(filterFn).forEach((p) => {
      !p.PAGE_TITLE && console.log('No title', p);
      const pageItem = {
        label: getMessage(p.PAGE_TITLE),
        title: p.PAGE_TITLE,
        key: p.PAGE_PATH,
        onClick: () => {
          props.addNewRecent({
            title: p.PAGE_TITLE,
            path: p.PAGE_PATH,
            icon: p.PAGE_ICON,
          });
          props.goTo(url.resolve('/', p.PAGE_PATH));
        },
        iconType: p.PAGE_ICON,
        extraAction: {
          color: 'subdued',
          onClick: () => {
            props.addFavorite({
              title: p.PAGE_TITLE,
              path: p.PAGE_PATH,
              icon: p.PAGE_ICON,
            });
          },
          iconType: favoritedList.includes(p.PAGE_PATH)
            ? 'starFilled'
            : 'starEmpty',
          iconSize: 's',
          'aria-label': 'Add to favorites',
        },
      };

      if (!p.MENU_NAME) {
        result.push({
          ...pageItem,
          extraAction: {
            color: 'subdued',
            onClick: () => {
              props.addNewRecent({
                title: getMessage(p.PAGE_TITLE),
                path: p.PAGE_PATH,
                icon: p.PAGE_ICON,
              });
            },
          },
        });
      } else {
        const index = result.findIndex((v) => v.key === p.MENU_NAME);
        const existed = get(result, `.${index}.flyoutMenu.listItems`, []).find(
          (v) => v.key === pageItem.key
        );
        if (index < 0 && !existed) {
          result.push({
            label: getMessage(p.MENU_TITLE),
            key: p.MENU_NAME,
            iconType: p.MENU_ICON,
            order: p.MENU_ORDER,
            flyoutMenu: {
              title: getMessage(p.MENU_TITLE),
              listItems: [pageItem],
            },
          });
        } else {
          result[index].flyoutMenu.listItems.push(pageItem);
        }
      }
    });

    return result;
  };

  const renderLogo = () => (
    <EuiHeaderLogo
      iconType="logoKibana"
      href="#/layout/nav-drawer"
      aria-label="Goes to home"
    />
  );

  const renderMenuTrigger = () => (
    <EuiHeaderSectionItemButton
      aria-label="Open nav"
      onClick={props.toggleOpenDrawer}
    >
      <EuiIcon type="apps" href="#" size="m" />
    </EuiHeaderSectionItemButton>
  );

  const renderBreadcrumbs = () => {
    const breadcrumbs = [
      {
        text: 'Management',
        href: '#',
        onClick: (e) => {
          e.preventDefault();
          console.log('You clicked management');
        },
        'data-test-subj': 'breadcrumbsAnimals',
        className: 'customClass',
      },
      {
        text: 'Truncation test is here for a really long item',
        href: '#',
        onClick: (e) => {
          e.preventDefault();
          console.log('You clicked truncation test');
        },
      },
      {
        text: 'hidden',
        href: '#',
        onClick: (e) => {
          e.preventDefault();
          console.log('You clicked hidden');
        },
      },
      {
        text: 'Users',
        href: '#',
        onClick: (e) => {
          e.preventDefault();
          console.log('You clicked users');
        },
      },
      {
        text: 'Create',
      },
    ];

    return <EuiHeaderBreadcrumbs breadcrumbs={breadcrumbs} />;
  };

  const buildTopLink = () => {
    const favoritedList = props.favoriteList.map((i) => i.path);
    return [
      {
        label: getMessage('layout.menu.recent_list'),
        iconType: 'clock',
        flyoutMenu: {
          title: getMessage('layout.menu.recent_list'),
          listItems: props.recentList.map((item) => ({
            label: getMessage(item.title),
            href: item.path,
            iconType: item.icon,
            extraAction: {
              color: 'subdued',
              iconType: favoritedList.includes(item.path)
                ? 'starFilled'
                : 'starEmpty',
              onClick: () => {
                props.addFavorite({
                  title: item.title,
                  path: item.path,
                  icon: item.icon,
                });
              },
              iconSize: 's',
              'aria-label': 'Remove from favorites',
              alwaysShow: true,
            },
          })),
        },
      },
      {
        label: getMessage('layout.menu.favorite_list'),
        iconType: 'starEmpty',
        flyoutMenu: {
          title: getMessage('layout.menu.favorite_list'),
          listItems: props.favoriteList.map((item, index) => ({
            label: `${index + 1}. ${getMessage(item.title)}`,
            iconType: item.icon,
            href: item.path,
            extraAction: {
              color: 'subdued',
              iconType: 'starFilled',
              onClick: () => props.removeFavorite(index),
              iconSize: 's',
              'aria-label': 'Remove from favorites',
              alwaysShow: true,
            },
          })),
        },
      },
    ];
  };

  useEffect(() => {
    if (navDrawerRef.current) {
      navDrawerRef.current.toggleOpen();
      navDrawerRef.current.toggleOpen();
      navDrawerRef.current.handleDrawerMenuClick = (e) => {
        console.log('Clicked', e.target.nodeName);
        if (!['BUTTON', 'svg'].includes(e.target.nodeName)) {
          return;
        }
        if (props.navLockStatus) {
          navDrawerRef.current.collapseDrawer();
          navDrawerRef.current.collapseFlyout();
        } else {
          navDrawerRef.current.expandDrawer();
          navDrawerRef.current.expandFlyout();
          navDrawerRef.current.sideNavLockClicked();
        }
      };
    }
  }, [props.navLockStatus]);

  const topMenu = buildMenu(
    (p) => p.MENU_GROUP === menuGroups.TOP || p.PAGE_GROUP === menuGroups.TOP
  );

  const mainMenu = buildMenu(
    (p) => p.MENU_GROUP === menuGroups.MAIN || p.PAGE_GROUP === menuGroups.MAIN
  );

  const bottomMenu = buildMenu(
    (p) =>
      p.MENU_GROUP === menuGroups.BOTTOM || p.PAGE_GROUP === menuGroups.BOTTOM
  );

  return (
    <EuiNavDrawer
      ref={navDrawerRef}
      isLocked={props.navLockStatus}
      onIsLockedUpdate={props.toggleNavDrawer}
    >
      <EuiNavDrawerGroup listItems={buildTopLink()} />
      {topMenu.length ? (
        <>
          <EuiSpacer size="s" />
          <EuiNavDrawerGroup listItems={topMenu} />
        </>
      ) : null}
      <EuiSpacer size="s" />
      <EuiNavDrawerGroup listItems={mainMenu} />
      {bottomMenu.length ? (
        <>
          <EuiSpacer size="s" />
          <EuiNavDrawerGroup listItems={bottomMenu} />
        </>
      ) : null}
    </EuiNavDrawer>
  );
};

const mapStateToProps = (stores) => ({
  navLockStatus: stores.app.navLockStatus,
  pageList: stores.auth.pageList,
  recentList: stores.app.recentList,
  favoriteList: stores.app.favoriteList,
});

const mapDispatchToProps = {
  toggleNavDrawer,
  addNewRecent,
  addFavorite,
  removeFavorite,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavDrawer);
